import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(({ px, tokens }) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: px(tokens.spacing[4]),
    fontSize: tokens.typography.variant.body2.fontSize,
    cursor: 'pointer',
  },
}));
